export const LEGAL_NOTICE_CONTENT = `
## 1. Datos identificativos

En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:

| Concepto | Dato |
| --- | --- |
| Titular | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Domicilio | C/ Felipe Sanclemente 8, 4B, 50001, Zaragoza, España |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://alejandrosn.com |

## 2. Objeto

El presente sitio web es la página personal y profesional de **AlejandroSN**, donde se presenta su oferta de desarrollo web, automatización y productos propios como Blunticle, además de su trayectoria y blog técnico. El sitio tiene carácter informativo y no requiere registro de usuario.

## 3. Condiciones de uso

El acceso y navegación por este sitio implica la aceptación de las presentes condiciones, así como de la [Política de Privacidad](/politica-privacidad) y la [Política de Cookies](/politica-cookies).

El usuario se compromete a:

- Utilizar el sitio de forma lícita y respetuosa.
- No intentar acceder sin autorización a sistemas o datos del titular.
- No reproducir contenidos sin autorización, salvo uso personal permitido por la ley.

## 4. Propiedad intelectual e industrial

Todos los contenidos del sitio —textos, diseño, código, logotipos, imágenes y artículos del blog— son propiedad de Alejandro Serrano Notivoli o de sus licenciantes, y están protegidos por la legislación española e internacional en materia de propiedad intelectual e industrial.

Queda prohibida su reproducción, distribución o transformación sin autorización expresa del titular, salvo en los casos permitidos por la ley.

## 5. Responsabilidad

El titular no se hace responsable de:

- Interrupciones del servicio por mantenimiento, causas técnicas o fuerza mayor.
- Contenidos de sitios de terceros enlazados desde este sitio.
- Decisiones tomadas por el usuario basándose en la información publicada en el blog o en las páginas informativas.

Los artículos del blog reflejan opiniones y experiencias personales en el momento de su publicación y pueden quedar desactualizados.

## 6. Legislación aplicable y jurisdicción

Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de Zaragoza, salvo que la normativa de consumo aplicable disponga otro fuero imperativo.
`;
